import socketio from 'socket.io-client';
import createSocketIoPlugin from 'vuex-socketio';
import camelCase from 'lodash/camelCase';

const opts = {
    path: '/ws/socket.io',
    transports: ['websocket'],
    forceNew: false,
    autoConnect: false,
};

const urlParams = new URLSearchParams(window.location.search);
const setupKey = urlParams.get('setupKey');
if (setupKey) {
    opts.query = {
        setupKey,
    };
}

const socketIoInstance = socketio(`wss://${window.location.host}`, opts);

export { socketIoInstance };

export const socketIoPlugin = createSocketIoPlugin(socketIoInstance, {
    converter: camelCase,
    onPrefix: 'socketOn_',
    emitPrefix: 'socketEmit_',
});
